import { trackInternalEvent } from '@rio/tracking'
import { useI18n } from 'builder/hooks/useI18n'
import { PrefillResumeEvents } from 'builder/modules/constants'
import createWithLinkedinImage from '../assets/create-with-linkedin.svg'
import { Props } from '../types'
import { useResumePrefill } from '../../hooks/useResumePrefill'
import {
  Card,
  CardTitleWrapper,
  CardTitle,
  ImageWrapper,
  Image,
  IconWrapper,
  ArrowIcon,
} from './styles'

export const CreateWithLinkedinProfile = ({ onClose }: Props) => {
  const { i18n } = useI18n()
  const { handleStartWithLinkedIn } = useResumePrefill()

  const handleCardClick = () => {
    trackInternalEvent(PrefillResumeEvents.clickCreateWithLiStartScreen)
    onClose()
    handleStartWithLinkedIn()
  }

  return (
    <Card onClick={handleCardClick}>
      <ImageWrapper>
        <Image src={createWithLinkedinImage} alt="With Linkedin Profile" />
      </ImageWrapper>
      <CardTitleWrapper>
        <CardTitle>{i18n.t('builder.prefill_resume.create_with_linkedin')}</CardTitle>
      </CardTitleWrapper>
      <IconWrapper>
        <ArrowIcon />
      </IconWrapper>
    </Card>
  )
}
